import { render, staticRenderFns } from "./AlLabel.vue?vue&type=template&id=3e4eb7b9&"
import script from "./AlLabel.vue?vue&type=script&lang=js&"
export * from "./AlLabel.vue?vue&type=script&lang=js&"
import style0 from "./AlLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports